export default __webpack_public_path__ + "b20c36e13b65ba730118f55f1c0c190c.svg";